<section id="content-wrapper" class="setUpStoreFront">
	<main id="site-main" class="sub-site-main">
		<div class="wrap">
			<div class="content-container my-order">
				<section class="data-table">
					<header class="data-table__header">
						<h2 class="page-heading tab-content-header active" id="products-content-header">
							<ng-container i18n="@@my_catalogue_details">My Catalogue Details</ng-container>
						</h2>

						<ng-container *ngIf="storeInfo?.vertical_type == 'food_beverage'">
							<button class="btn py-2 px-3 w-auto" (click)="onApplyBranch()" *ngIf="!storeInfo.is_branch" i18n="@@store.activate_multi_branch">Activate Multi Branch</button>
							<button class="btn py-2 px-3 w-auto" (click)="onDeactivateBranch()" *ngIf="storeInfo.is_branch" i18n="@@store.deactivate_multi_branch">Deactivate Multi Branch</button>
						</ng-container>
					</header>

					<div class="data-table__wrap">
						<div class="header_options flex-none-column align-items-none-start gap-none-4">
							<div class="header_option">
								<div class="d-flex gap-2 align-items-center pointer">
									<ng-container i18n="@@receive_orders">Receive orders</ng-container>
									<div class="tooltip_wrapper">
										<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
											<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<div class="help_tooltip_text">
											<ng-container i18n="@@receive_orders_tooltip"> Turn this on if your business is currently open for new orders. When this is disabled, your store will show as “closed” to your customers and they will not be able to place an order. </ng-container>
											<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
												<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
											</svg>
										</div>
									</div>
								</div>
								<div class="switch-wrapper">
									<div class="switch">
										<input class="product-switch" type="checkbox" id="auto-renew" name="auto-renew" [(ngModel)]="shopStatus">
										<span class="slider round"></span>
									</div>
								</div>
							</div>
							<div class="header_option">
								<div class="d-flex gap-2 align-items-center pointer">
									<ng-container i18n="@@auto_accept_order">Auto accept order</ng-container>
									<div class="tooltip_wrapper">
										<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
											<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<div class="help_tooltip_text">
											<ng-container i18n="@@auto_accept_order_tooltip">Turn this on if you would like to automatically accept orders from customers without having to manually review and accept them. </ng-container>
											<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
												<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
											</svg>
										</div>
									</div>
								</div>
								<div class="switch-wrapper">
									<div class="switch">
										<input class="product-switch" type="checkbox" id="auto-renew" name="auto-renew" [(ngModel)]="autoAccept">
										<span class="slider round"></span>
									</div>
								</div>								
							</div>
							
							<div class="header_option" *ngIf="branches?.length">
								<div class="d-flex gap-2 align-items-center pointer">
									<h3 class="mb-0">Order Receiving Branch :</h3>
									<!-- <div class="tooltip_wrapper">
										<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
											<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<div class="help_tooltip_text">
											<ng-container i18n="@@auto_accept_order_tooltip">Turn this on if you would like to automatically accept orders from customers without having to manually review and accept them. </ng-container>
											<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
												<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
											</svg>
										</div>
									</div> -->
								</div>
								<div class="switch-wrapper">
									<!-- View Mode -->
									<ng-container *ngIf="!showBranches">
										<span class="d-flex align-items-center gap-1">
											{{ defaultBranch?.name }}
											<svg (click)="changeBranch('open')" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" class="edit_product cursor-pointer" >
												<path d="M15.0002 8.33326L11.6669 4.99993M2.0835 17.9166L4.9038 17.6032C5.24838 17.5649 5.42067 17.5458 5.5817 17.4937C5.72457 17.4474 5.86054 17.3821 5.9859 17.2994C6.12721 17.2062 6.24978 17.0836 6.49493 16.8385L17.5002 5.83326C18.4207 4.91279 18.4207 3.4204 17.5002 2.49993C16.5797 1.57945 15.0873 1.57945 14.1669 2.49992L3.1616 13.5052C2.91645 13.7503 2.79388 13.8729 2.70069 14.0142C2.61802 14.1396 2.55268 14.2755 2.50642 14.4184C2.45429 14.5794 2.43515 14.7517 2.39686 15.0963L2.0835 17.9166Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ></path>
											</svg>
										</span>
									</ng-container>

									<!-- Edit Mode -->
									<ng-container *ngIf="showBranches">
										<div class="d-flex align-items-center gap-2">
											<select
												app-select2
												class="form-control"
												style="min-width: 200px;"
												[options]="{
													data: branches,
													idColumn: 'id',
													textColumn: 'name',
													dropdownParent: 'form.new-record'
												}"
												[(ngModel)]="selectedBranchId"
												[ngModelOptions]="{ standalone: true }"
												(itemSelected)="onChangeBranch($event)"
												data-placeholder="Select Branch"
												[selected]="defaultBranch ? { id: defaultBranch.id, text: defaultBranch.name } : null"
												>
												<option></option>
											</select>

											<!-- Close Icon -->
											<a href="javascript:void(0)" (click)="changeBranch('close')">
												<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 20" fill="none">
													<path d="M15.5 5L5.5 15M5.5 5L15.5 15" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												</svg>
											</a>
										</div>
									</ng-container>
								</div>								
							</div>
						</div>

						<header class="data-table__controls">
							<div class="select-date-from select-pages">
								<div class="select-pages_tabs">
									<ul class="tabs_content">
										<li class="tab_item" [class.active]="activeTab == 'general'" data-target="general" (click)="tabChange('general', 'tab')">
											<ng-container i18n="@@store.general">General</ng-container>
										</li>
										<li class="tab_item" [class.active]="activeTab == 'store-address'" data-target="store-address" (click)="tabChange('store-address', 'tab')">
											<ng-container i18n="@@store.store_address">Store address</ng-container>
										</li>
										<li class="tab_item" [class.active]="activeTab == 'product-listing'" data-target="product-listing" (click)="tabChange('product-listing', 'tab')">
											<ng-container i18n="@@store.product_listing">Product listing</ng-container>
										</li>
										<li class="tab_item service_hide" [class.disabled]="!isAllowDeliveryPaymentPartners" [class.active]="activeTab == 'delivery-options'" data-target="delivery-options" (click)="isAllowDeliveryPaymentPartners && tabChange('delivery-options', 'tab')">
											<ng-container i18n="@@store.delivery_options">Delivery</ng-container>
										</li>
                                        <li class="tab_item" [class.disabled]="!isAllowPromocodes" [class.active]="activeTab == 'marketing'" data-target="marketing" (click)="isAllowPromocodes && tabChange('marketing', 'tab')">
											<ng-container i18n="@@store.marketing">Marketing</ng-container>
										</li>
									</ul>
								</div>
							</div>
						</header>

						<div class="tab-content">
							<div class="tab-content data-table__tab-content" id="pills-tabContent">
								<form [formGroup]="storeInformationForm" (ngSubmit)="onSubmit()" id="ngForm" #informationForm="ngForm">
								<div class="tab-pane fade" [class.show]="activeTab == 'general'" [class.active]="activeTab == 'general'" id="general-content" role="tabpanel" aria-labelledby="pills-all-order-tab">
									<div id="my-store_info" style="width: 100%">


										<div class="catalogue-details__uploader">
											<div class="catalogue-details__uploaderTexts">
												<p i18n="@@upload_catalogue_cover_photo">Upload catalogue cover photo</p>
												<span i18n="@@png_jpg_files_are_allowed">PNG, JPG files are allowed</span>
											</div>
											<fieldset class="logo-uploder">
												<file-pond #logoFile
													[options]="pondOptions"
													[files]="coverImageUrl"
													(oninit)="pondHandleInit()"
													(onaddfile)="pondHandleAddFile($event)"
													(onprocessfileabort)="pondHandleRemoveFile($event)"
													>
												</file-pond>
											</fieldset>
											<div class="catalogue-details__uploaderUploadText">
												<span i18n="@@drag_drop_file">Drag and drop or browse to choose a file</span>
											</div>
										</div>


										<div class="user_info_container">
											<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
												<div class="w-50 w-none-100">
													<fieldset [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
														<label i18n="@@business.business_name">Business Name</label><span class="required-star">*</span>
														<input type="text" name="store-name" formControlName="name" (keyup)="convertToSlug($event.target.value)" (blur)="convertToSlug($event.target.value)" />
														<span class="field-error" i18n="@@error.required.store_name" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Store name is required</span>
														<span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
													</fieldset>
												</div>
												<div class="w-50 w-none-100" style="margin-top: .5rem;">
													<label i18n="@@business_type">Business Type</label>
													<div class="radio-group d-flex justify-content-start align-items-center gap-5 flex-none-column align-items-none-start" id="business-type" style="margin-top: .5rem;">
														<div class="d-flex align-items-center gap-3">
															<input type="radio" id="store-product" name="business-type" class="custom-radio" name="add-storeItem" (click)="onBusinessTypeChange.emit('product')" [attr.checked]="myStoreType == 'product' ? true : false">
															<label class="m-0" for="store-product" i18n="@@common.product">Product</label>
														</div>
														<div class="d-flex align-items-center gap-3">
															<input type="radio" id="store-service" name="business-type" class="custom-radio" name="add-storeItem" (click)="onBusinessTypeChange.emit('service')" [checked]="myStoreType == 'service'">
															<label class="m-0" for="store-service" i18n="@@common.service">Service</label>
														</div>
													</div>
												</div>
											</div>
											<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
												<div class="status_wrap w-50 w-none-100 store-information--box">
													<fieldset class="add-categories pb-4" [ngClass]="{ 'has-error': (isSubmitted || f.storefront_categories.dirty) && f.storefront_categories?.errors }">
														<label>
															<ng-container i18n="@@store.add_categories">Storefront Categories</ng-container>
														</label>
														<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: storeFrontCategoriesApi}, idColumn: 'id',textColumn: 'name', maxLength: 3}" [selected]="selectedStorefrontCategories ? selectedStorefrontCategories : null" i18n-data-placeholder="@@store.add_storefront_categories" data-placeholder="Add Storefront Categories" formControlName="storefront_categories" multiple="multiple"></select>
														<span class="field-error" *ngIf="(isSubmitted || f.storefront_categories.dirty) && f.storefront_categories.errors?.required">Add at least one category</span>
														<span class="field-error" *ngIf="f.storefront_categories.errors?.serverError">{{ f.storefront_categories.errors?.serverError }}</span>
													</fieldset>
												</div>
												<div class="w-50 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.slug.dirty) && f.slug?.errors }">
														<label class="catalogue-details__labelTip" i18n="@@store.catalogue_link_name">Catalogue Link Name <span>(Useful for sending shop URLs to customers)</span></label>
														<div class="catalogue-details__copyField">
															<input type="text" name="catalogue_link" #slug formControlName="slug" (keyup)="convertToSlug(slug.value)" (blur)="convertToSlug(slug.value)" />
															<span class="copy" i18n="@@store.copy" (click)="copyText()">Copy</span>
														</div>
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.required">Required</span>
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.slugTaken">Slug is already taken</span>
														<span class="field-error" *ngIf="f.slug.errors?.serverError">{{ f.slug.errors?.serverError }}</span>
														<span class="catalogue-details__businessUrl" >{{ storeUrl }}</span>
													</fieldset>
												</div>
											</div>

											<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
												<div class="status_wrap store-information--box">
													<fieldset class="add-categories pb-4">
														<label>
															<ng-container i18n="@@store.add_categories">Add product Categories</ng-container>
														</label>
														<select class="categories select2-hidden-accessible" app-select2-multiple [options]="{ajax: {url: productCategoriesApi}, idColumn: 'name',textColumn: 'name', tags: true}" (onUnselect)="onUnselectProductCategory($event)" [selected]="selectedProductCategories ? selectedProductCategories : null" i18n-data-placeholder="@@store.add_product_categories" data-placeholder="Add Product Categories" formControlName="product_categories" multiple="multiple"></select>

														<span class="field-error" *ngIf="(isSubmitted || f.product_categories.dirty) && f.product_categories.errors?.required">Add at least one category</span>
														<span class="field-error" *ngIf="f.product_categories.errors?.serverError">{{ f.product_categories.errors?.serverError }}</span>
													</fieldset>
												</div>
											</div>

											<div class="w-100">
												<div class="input-group">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.description.dirty) && f.description?.errors }">
														<div class="d-flex gap-2 align-items-start pointer">
															<label>
																<ng-container i18n="@@business_description">Business Description</ng-container>															
															</label>
															<div class="tooltip_wrapper">
																<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
																	<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																	<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																</svg>
																<div class="help_tooltip_text">
																	<ng-container i18n="@@store.business_description_tooltip">
																		Add a short description of your business. This will appear in your store.
																	</ng-container>
																	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																		<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																	</svg>
																</div>
															</div>
														</div>														
														<textarea name="description" rows="5" formControlName="description"></textarea>
														<span *ngIf="(isSubmitted || f.description.dirty) && f.description.errors?.required" i18n="@@error.required.description" class="field-error">Description is required</span>
													</fieldset>
												</div>
											</div>
											<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
												<div class="w-50 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.phone.dirty) && f.phone?.errors }">
														<label i18n="@@store.phone_number">Phone Number</label>
														<input type="number" name="phone" formControlName="phone" maxlength="15" />
														<span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.required">Phone number is required </span>
														<span class="field-error" i18n="@@error.phone_number_only" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.pattern">Please enter number only </span>
														<span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.phone.dirty) && (f.phone.errors?.minlength || f.phone.errors?.maxlength)">The phone number must be less than 5 and 30 digits</span>
														<span class="field-error" *ngIf="f.phone.errors?.serverError">{{ f.phone.errors?.serverError }}</span>
													</fieldset>
												</div>
												<div class="w-50 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone?.errors }">
														<label  i18n="@@store.whatsapp_business_number">Whatsapp Business Number</label>
														<div class="catalogue-details__whatsappNumber">
															<label class="whatsapp-number" for="whatsapp-number">https://wa.me/+{{ basicInfo?.calling_code }}</label>
															<input type="number" placeholder="+966 123 456 789" id="whatsapp-number" name="store-name" formControlName="whatsapp_phone"/>
															<span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.required">Whatsapp number is required </span>
															<span class="field-error" i18n="@@error.whatsapp_phone_number_only" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.pattern">Please enter number only </span>
															<span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && (f.whatsapp_phone.errors?.minlength || f.whatsapp_phone.errors?.maxlength)">The Whatsapp number must be less than 5 and 30 digits</span>
															<span class="field-error" *ngIf="f.whatsapp_phone.errors?.serverError">{{ f.whatsapp_phone.errors?.serverError }}</span>
														</div>
													</fieldset>
												</div>
											</div>
										</div>
										<div class="user_info_container gap-3">
											<div class="d-flex align-items-center gap-2 mb-2">
												<div class="custom-checkbox">
													<input class="select-item orders_inputAll" id="allow-instant-order" type="checkbox" formControlName="allow_instant_order">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<label for="allow-instant-order" i18n="@@store.allow_instant_order" style="margin-bottom: 0;">
													Allow instant order
												</label>
											</div>

											<div class="d-flex align-items-center gap-2 mb-2">
												<div class="custom-checkbox">
													<input class="select-item orders_inputAll" id="allow-scheduled-order" type="checkbox" formControlName="allow_scheduled_order">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<label for="allow-scheduled-order" i18n="@@store.allow_scheduled_order" style="margin-bottom: 0;">
													Allow scheduled order
												</label>
											</div>

											<div class="d-flex align-items-center gap-2 mb-2">
												<div class="custom-checkbox">
													<input class="select-item orders_inputAll" id="checkbox-001" type="checkbox" formControlName="upload_reference_files">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<label for="checkbox-001" i18n="@@allow_customers_to_upload_reference_files" style="margin-bottom: 0;">
													Allow customers to upload reference files
												</label>
											</div>

											<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
											<!--- Additional info part--->
												<!-- <div class="d-flex gap-2 align-items-center">
													<div class="custom-checkbox show_mandatory">
														<input tm-toggle="additioanl-information" class="select-item orders_inputAll" id="checkbox-002" type="checkbox" formControlName="allow_additional_info" >
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="checkbox-002" i18n="@@allow_customers_to_add_additional_info">
														Allow customer to add additional info
													</label>
												</div> -->
											<!--- End additional info part --->
												<div class="d-flex gap-2 align-items-center">
													<div class="custom-checkbox show_mandatory">
														<input tm-toggle="additioanl-information" class="select-item orders_inputAll" id="checkbox-002" type="checkbox" formControlName="allow_additional_info" >
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="checkbox-002" i18n="@@allow_customers_to_add_additional_info" style="margin-bottom: 0;">
														Allow customer to add additional info
													</label>
												</div>
												<div class="tooltip_wrapper">
													<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
														<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
													<div class="help_tooltip_text" data-role="right">
														<ng-container i18n="@@store.allow_customers_to_add_additional_info_tooltip">
															Enable this field for your customers to add any comments during checkout.
														</ng-container>
														<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
															<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
														</svg>
													</div>
												</div>
											</div>
											<!-- <div id="additioanl-information" class="align-items-center gap-4 mb-2 flex-none-column align-items-none-start mandatory_field" >
												<div class="w-100 position-relative w-none-98">
													<ng-container formArrayName="additional_info">
														<ng-container *ngFor="let item of additionalInfo.controls; let i=index" [formGroupName]="i">
															<div class="catalogue-details-additionalInfo__textarea" >
																<div class="catalogue-details-additionalInfo__input" >
																	<label i18n="@@setting.additional_info" *ngIf="i==0; else noAdditionalInfoLabel">Additional information</label>
																	<ng-template #noAdditionalInfoLabel> &nbsp;&nbsp;</ng-template>
																	<fieldset class="mb-0"  [ngClass]="{ 'has-error': isSubmitted && getInformationFormGroup(i).get('information')?.invalid }">
																		<textarea name="description" i18n-placeholder="@@setting.additional_info" placeholder="Additional information" formControlName="information" maxlength="78"></textarea>
																		<span  class="field-error" i18n="@@error.required" *ngIf="isSubmitted&& getInformationFormGroup(i).get('information')?.errors?.required">* Required</span>
																	</fieldset>
																</div>
																<div class="catalogue-details-additionalInfo__action">
																	<div class="catalogue-details-additionalInfo__actionCheckbox">
																		<div class="custom-checkbox">
																			<input class="select-item orders_inputAll" id="index-{{i}}" type="checkbox" formControlName="make_mandatory" (click)="makeMandatory(i, $event)">
																			<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																				<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"></rect>
																			</svg>
																			<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"></rect>
																				<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																			</svg>
																		</div>
																		<label for="index-{{i}}" i18n="@@make_mandatory">Make mandatory</label>
																	</div>
																</div>
																<a href="javascript:void(0)" *ngIf="i != 0" (click)="deleteAdditionalInfo(i)">
																	<svg class="close_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																		<path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																	</svg>
																</a>
															</div>
														</ng-container>
													</ng-container>
												</div>
												<div class="w-50 d-flex align-items-center gap-2 pl-4 w-none-100 pl-none-0">
												</div>
											</div> -->

											<!--- Additional info part--->
											<!-- <div class="user_info_container gap-3" [class.d-none]="!f.allow_additional_info.value">
												<ng-container formArrayName="additional_info">
													<ng-container *ngFor="let item of additionalInfo.controls; let i=index" [formGroupName]="i">
														<div class="align-items-center gap-4 flex-none-column align-items-none-start mandatory_field" >
															<div class="w-50 position-relative w-none-98">
																<div class="input-group">
																	<fieldset class="no-label mb-0"  [ngClass]="{ 'has-error': isSubmitted && getInformationFormGroup(i).get('information')?.invalid }">
																		<textarea name="description" i18n-placeholder="@@setting.additional_info" placeholder="Additional information" formControlName="information" maxlength="78"></textarea>
																		<span  class="field-error" i18n="@@error.required" *ngIf="isSubmitted && getInformationFormGroup(i).get('information')?.errors?.required">* Required</span>
																	</fieldset>
																</div>
																<div class="d-flex justify-content-between pt-2">
																	<div class="d-flex align-items-center gap-3">
																		<div class="custom-checkbox">
																			<input class="select-item orders_inputAll" id="index-{{i}}" type="checkbox" formControlName="make_mandatory" (click)="makeMandatory(i, $event)">
																			<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																				<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
																			</svg>
																			<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
																				<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																			</svg>
																		</div>
																		<label for="index-{{i}}" i18n="@@make_mandatory">Make mandatory</label>
																	</div>
																</div>
																<svg class="close_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" *ngIf="i != 0" (click)="deleteAdditionalInfo(i)">
																	<path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																</svg>
															</div>
															<div class="w-50 d-flex align-items-center gap-2 pl-4 w-none-100 pl-none-0">
															</div>
														</div>
													</ng-container>
												</ng-container>

												<button type="button" id="add_field" class="add_field mt-4" (click)="addAdditionalInfo()">
													<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
														<path d="M10.0001 4.16666V15.8333M4.16675 9.99999H15.8334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
													<ng-container i18n="@@add_another">Add field</ng-container>
												</button>
											</div> -->
											<!---End Additional info part--->

											<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
												<div class="d-flex gap-2 align-items-center">
													<div class="custom-checkbox show_comments">
														<input tm-toggle="shop-comments" class="select-item orders_inputAll" id="checkbox-005" type="checkbox" formControlName="allow_shop_comment" (click)="allowShopComments($event)">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="checkbox-005" i18n="@@add_shop_comments" style="margin-bottom: 0;">Add Shop comments </label>
												</div>
												<div class="tooltip_wrapper">
													<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
														<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
													<div class="help_tooltip_text" data-role="right">
														<ng-container i18n="@@store.add_shop_comments_tooltip">
															Enable this field to add a visible shop comment / note.
														</ng-container>
														<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
															<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
														</svg>
													</div>
												</div>
											</div>
											<div id="shop-comments" class="align-items-center gap-4 mb-2 flex-none-column align-items-none-start comments_field" [class.d-none]="!f.allow_shop_comment.value">
												<div class="w-50 position-relative w-none-98">
													<div class="input-group">
														<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.shop_comments.dirty) && f.shop_comments?.errors }">
															<label i18n="@@shop_comments">Shop Comment</label>
															<textarea placeholder="e.g Please note any orders placed past 5pm will be rejected" formControlName="shop_comments" ></textarea>
															<span *ngIf="(isSubmitted || f.shop_comments.dirty) && f.shop_comments.errors?.required" i18n="@@error.required" class="field-error">Shop Comment is required</span>
														</fieldset>
													</div>
												</div>
											</div>
										</div>


										<div class="user_info_container gap-3 service_hide working_hours">
											<h3 class="w-100 mb-2">
												<div class="d-flex gap-2 align-items-start pointer">
													<ng-container i18n="@@store.specify_working_hours">Specify Working Hours</ng-container>
													<div class="tooltip_wrapper">
														<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
															<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
														<div class="help_tooltip_text" data-role="right">
															<ng-container i18n="@@store.specify_working_hours_tooltip">
																Set the hours your store will be open for orders.
																When your store is closed customers will not be
																able to place an order, but will see when the
																next opening time will be.
															</ng-container>															
															<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
															</svg>
														</div>
													</div>
												</div>
											</h3>
											<ng-container formGroupName="week_days">
												<div class="d-flex align-items-center gap-2 mb-2">
													<div class="custom-checkbox">
														<input type="checkbox" class="select-item orders_inputAll" formControlName="same_everyday">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<ng-container i18n="@@store.same_everyday">Same everyday</ng-container>											
												</div>

											
												<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
													<div class="w-50 w-none-100">
														<ng-container formGroupName="monday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.monday">
																	<div class="custom_accordion-header" (click)="openTimeModel('monday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Monday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.monday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('monday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('monday').length > 1 && i > 0" role="button" (click)="removeSlot('monday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('monday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
													<div class="w-50 w-none-100">
														<ng-container formGroupName="tuesday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.tuesday">
																	<div class="custom_accordion-header" (click)="openTimeModel('tuesday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Tuesday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.tuesday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('tuesday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('tuesday').length > 1 && i > 0" role="button" (click)="removeSlot('tuesday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('tuesday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
												</div>

												<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
													<div class="w-50 w-none-100">
														<ng-container formGroupName="wednesday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.wednesday">
																	<div class="custom_accordion-header" (click)="openTimeModel('wednesday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Wednesday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.wednesday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('wednesday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('wednesday').length > 1 && i > 0" role="button" (click)="removeSlot('wednesday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('wednesday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
													<div class="w-50 w-none-100">
														<ng-container formGroupName="thursday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.thursday">
																	<div class="custom_accordion-header" (click)="openTimeModel('thursday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Thursday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.thursday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('thursday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('thursday').length > 1 && i > 0" role="button" (click)="removeSlot('thursday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('thursday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
												</div>

												<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
													<div class="w-50 w-none-100">
														<ng-container formGroupName="friday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.friday">
																	<div class="custom_accordion-header" (click)="openTimeModel('friday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Friday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.friday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('friday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('friday').length > 1 && i > 0" role="button" (click)="removeSlot('friday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('friday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
													<div class="w-50 w-none-100">
														<ng-container formGroupName="saturday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.saturday">
																	<div class="custom_accordion-header" (click)="openTimeModel('saturday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Saturday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.saturday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('saturday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('saturday').length > 1 && i > 0" role="button" (click)="removeSlot('saturday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('saturday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
												</div>

												<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
													<div class="w-50 w-none-100">
														<ng-container formGroupName="sunday">
															<div class="custom_accordion">
																<div class="custom_accordion-item" [class.active]="!timeModel.sunday">
																	<div class="custom_accordion-header" (click)="openTimeModel('sunday')">
														
																		<div class="d-flex align-items-center gap-3">
																			<div class="switch-wrapper">
																				<div class="switch">
																					<input class="product-switch" type="checkbox" formControlName="available">
																					<span class="slider round"></span>
																				</div>
																			</div>
																			Sunday
																		</div>
														
																		<svg class="custom_accordion-icon" width="24" height="24">
																			<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" />
																		</svg>
																	</div>
														
																	<div class="custom_accordion-content" [class.d-none]="!timeModel.sunday">
																		<div formArrayName="slots">
														
																			<div *ngFor="let slot of getSlots('sunday').controls; let i = index" [formGroupName]="i">
																				<div class="field_cont rounded">
																					<!-- OPENING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('start_time')?.hasError('required') || slot.hasError('slotOrderInvalid') }">
																						<label i18n="@@store.opening_time">Opening Time</label>
																						<div formGroupName="new_start_time_group" class="timing opening">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
																						<span class="field-error" *ngIf="slot.get('start_time')?.hasError('required')" i18n="@@error.required.opening_time">Opening time is required</span>

																						<span class="field-error" *ngIf="slot.hasError('slotOrderInvalid')">Each slot must start after the previous slot ends.</span>
																					</fieldset>
															
																					<!-- CLOSING TIME -->
																					<fieldset class="no-label" [ngClass]="{ 'has-error': slot.get('end_time')?.hasError('required') || slot.errors?.timeInvalid }">
																						<label>Closing Time</label>
																						<div formGroupName="new_end_time_group" class="timing">
																							<div class="input-wrapper">
															
																								<fieldset>
																									<select nice-select formControlName="hours">
																										<option *ngFor="let h of hours" [value]="h">{{h}}</option>
																									</select>
																									<span>H</span>
																								</fieldset>
															
																								<fieldset>
																									<select nice-select formControlName="minutes">
																										<option *ngFor="let m of minutes" [value]="m">{{m}}</option>
																									</select>
																									<span>M</span>
																								</fieldset>
															
																							</div>
																						</div>
															
																						<span class="field-error" *ngIf="slot.get('end_time')?.hasError('required')" i18n="@@error.required.closing_time">Closing time is required</span>

																						<span class="field-error" *ngIf="slot.errors?.timeInvalid" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																					</fieldset>
															
																					<!-- REMOVE BUTTON -->
																					<span *ngIf="getSlots('sunday').length > 1 && i > 0" role="button" (click)="removeSlot('sunday', i)">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>

																					<!-- ADD BUTTON -->
																					<span *ngIf="i == 0" role="button" (click)="addSlot('sunday')">
																						<svg class="btn__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																							<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																						</svg>
																					</span>
																				</div>
																			</div>
																		</div>
											
																	</div>
																</div>
															</div>
														</ng-container>
													</div>
												</div>

											</ng-container>
										</div>

										<div class="user_info_container gap-3">
											<div class="w-100">
												<div class="input-group">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.terms_conditions.dirty) && f.terms_conditions?.errors }">
														<div class="d-flex gap-2 align-items-start pointer">
															<label>
																<ng-container i18n="@@store.business_terms_conditions">Terms and conditions</ng-container>															
															</label>
															<div class="tooltip_wrapper">
																<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
																	<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																	<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																</svg>
																<div class="help_tooltip_text">
																	<ng-container i18n="@@store.business_terms_and_conditions_tooltip">
																		Add a Terms and conditions of your business. This will appear in your store.
																	</ng-container>
																	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																		<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																	</svg>
																</div>
															</div>
														</div>														
														<textarea name="terms_conditions" rows="5" formControlName="terms_conditions"></textarea>
														<span *ngIf="(isSubmitted || f.terms_conditions.dirty) && f.terms_conditions.errors?.required" i18n="@@error.required.terms_conditions" class="field-error">Terms and conditions is required</span>
													</fieldset>
												</div>
											</div>
										</div>

										<div class="user_info_container gap-3">
											<div class="w-100">
												<div class="input-group">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.privacy_policy.dirty) && f.privacy_policy?.errors }">
														<div class="d-flex gap-2 align-items-start pointer">
															<label>
																<ng-container i18n="@@store.business_privacy_policy">Privacy and policy</ng-container>															
															</label>
															<div class="tooltip_wrapper">
																<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
																	<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																	<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																</svg>
																<div class="help_tooltip_text">
																	<ng-container i18n="@@store.business_privacy_policy_tooltip">
																		Add a Privacy and policy of your business. This will appear in your store.
																	</ng-container>
																	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																		<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																	</svg>
																</div>
															</div>
														</div>														
														<textarea name="privacy_policy" rows="5" formControlName="privacy_policy"></textarea>
														<span *ngIf="(isSubmitted || f.privacy_policy.dirty) && f.privacy_policy.errors?.required" i18n="@@error.required.privacy_policy" class="field-error">Privacy and policy is required</span>
													</fieldset>
												</div>
											</div>
										</div>

										<div class="d-flex w-100 align-items-center justify-content-end mt-4">
											<button type="button" class="add_field continue" (click)="tabChange('store-address', 'button')">
												<ng-container i18n="@@continue">Continue</ng-container>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</button>
											<!-- <a href="javascript:void(0)" class="tu-btn blue update" form="ngForm" (click)="informationForm.ngSubmit.emit()" i18n="@@submit_catlogue_details">Submit catlogue details</a> -->
										</div>
									</div>
								</div>

								<div class="tab-pane fade" [class.show]="activeTab == 'store-address'" [class.active]="activeTab == 'store-address'" id="store-address-content" role="tabpanel" aria-labelledby="pills-new-tab">
									<div id="my-store_info" style="width: 100%">


										<div class="user_info_container gap-4 d-flex justify-content-between align-items-center flex-row flex-none-column align-items-none-start">
											<div class="w-50 service_hide  w-none-100">
												<fieldset [ngClass]="{ 'has-error': (isSubmitted || f.address.dirty) && f.address?.errors }">
													<label> <ng-container i18n="@@google_pin_drop_location">Google pin drop location </ng-container> <a class="city-link" href="javascript:void(0)" (click)="openGoogleMap()" i18n="@@open_map"> open map</a></label>
													<input type="text" name="drop-location" formControlName="address" readonly>
													<span class="field-error" i18n="@@error.required.address" *ngIf="(isSubmitted || f.address.dirty) && f.address.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.address.errors?.serverError">{{ f.address.errors?.serverError }}</span>
												</fieldset>
											</div>
											<div class="w-50 service_hide"></div>
										</div>

										<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.building_name.dirty) && f.building_name?.errors }">
													<label i18n="@@business.building_name">Building Name</label>
													<input type="text" name="building_name" formControlName="building_name" (keypress)="validateInput($event)" />
													<span class="field-error" i18n="@@error.required.building_name" *ngIf="(isSubmitted || f.building_name.dirty) && f.building_name.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.building_name.errors?.serverError">{{ f.building_name.errors?.serverError }}</span>
												</fieldset>
											</div>
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.street.dirty) && f.street?.errors }">
													<label i18n="@@business.street">Street</label>
													<input type="text" name="street" formControlName="street" (keypress)="validateInput($event)" />
													<span class="field-error" i18n="@@error.required.street" *ngIf="(isSubmitted || f.street.dirty) && f.street.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.street.errors?.serverError">{{ f.street.errors?.serverError }}</span>
												</fieldset>
											</div>
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.area.dirty) && f.area?.errors }">
													<label i18n="@@business.area">Area</label>
													<input type="text" name="area" formControlName="area" (keypress)="validateInput($event)" />
													<span class="field-error" i18n="@@error.required.area" *ngIf="(isSubmitted || f.area.dirty) && f.area.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.area.errors?.serverError">{{ f.area.errors?.serverError }}</span>
												</fieldset>
											</div>
										</div>

										<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.country_id.dirty) && f.country_id?.errors }">
													<label i18n="@@store.country">Country</label>
													<select
														app-select2
														[options]="{
															ajax: {url: countryListApi},
															idColumn: 'id',
															textColumn: 'name'
														}" (itemSelected)="onChangeCountry($event)" [selected]="selectedCountry ? {id: selectedCountry?.id, text: selectedCountry?.name} : null" i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name" name="country_id" formControlName="country_id">
													<option></option>
													</select>
													<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.country_id.dirty) && f.country_id.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.country_id.errors?.serverError">{{ f.country_id.errors?.serverError }}</span>
												</fieldset>
											</div>

											<ng-container *ngIf="outsideSA; else insideSA">
												<div class="d-flex flex-column w-50 gap-3 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.city.dirty) && f.city?.errors }">
														<label i18n="@@store.city">City</label>
														<input type="text" name="city" formControlName="city" >
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.city.dirty) && f.city.errors?.required">Required</span>
														<span class="field-error" *ngIf="f.city.errors?.serverError">{{ f.city.errors?.serverError }}</span>
													</fieldset>
												</div>
											</ng-container>
											<ng-template #insideSA>
												<div class="d-flex flex-column w-50 gap-3 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.region_id.dirty) && f.region_id?.errors }">
														<label i18n="@@store.region">Region</label>
														<select app-select2 [options]="{
																ajax: {url: regionListApi},
																idColumn: 'id',
																textColumn: 'name'
															}" (itemSelected)="onChangeRegion($event)" [selected]="selectedRegion ? {id: selectedRegion.id, text: selectedRegion.name}  : {}" i18n-placeholder="@@store.please_select" data-placeholder="Select Region" formControlName="region_id">
															<option></option>
														</select>
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.region_id.dirty) && f.region_id.errors?.required">Required</span>
														<span class="field-error" *ngIf="f.region_id.errors?.serverError">{{ f.region_id.errors?.serverError }}</span>
													</fieldset>
												</div>
												<div class="d-flex flex-column w-50 gap-3 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.city_id.dirty) && f.city_id?.errors }">
														<label i18n="@@store.city">City</label>
														<select app-select2 [options]="{
																data: cities ? cities : [],
																idColumn: 'id',
																textColumn: 'name'
															}" [params]="{cityId:f.region_id.value}" (itemSelected)="onChangeCity($event)" [selected]="selectedCity ? {id: selectedCity.id, text: selectedCity.name}  : {}" i18n-placeholder="@@store.please_select" placeholder="Select City" data-placeholder="Select City" formControlName="city_id">
															<option></option>
														</select>
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.city_id.dirty) && f.city_id.errors?.required">Required</span>
														<span class="field-error" *ngIf="f.city_id.errors?.serverError">{{ f.city_id.errors?.serverError }}</span>
													</fieldset>
												</div>
												<div class="d-flex flex-column w-50 gap-3 w-none-100">
													<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.district_id.dirty) && f.district_id?.errors }">
														<label i18n="@@store.district">District</label>
														<select app-select2 [options]="{
																data: districts ? districts : [],
																idColumn: 'id',
																textColumn: 'name'
															}" [selected]="selectedDistrict ? {id: selectedDistrict.id, text: selectedDistrict.name}  : {}" i18n-placeholder="@@store.please_select" placeholder="Select District" data-placeholder="Select District" formControlName="district_id">
															<option></option>
														</select>
														<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.district_id.dirty) && f.district_id.errors?.required">Required</span>
														<span class="field-error" *ngIf="f.district_id.errors?.serverError">{{ f.district_id.errors?.serverError }}</span>
													</fieldset>
												</div>
											</ng-template>
										</div>


										<div class="d-flex w-100 align-items-center justify-content-end mt-4">
											<button type="button" class="add_field continue" *ngIf="isAllowDeliveryPaymentPartners && isAllowPromocodes" (click)="tabChange('delivery-options', 'button')">
												<ng-container i18n="@@continue">Continue</ng-container>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</button>

											<div class="d-flex w-100 align-items-center justify-content-end mt-4" *ngIf="!isAllowDeliveryPaymentPartners && !isAllowPromocodes">
												<a href="javascript:void(0)" class="tu-btn blue update" form="ngForm" (click)="informationForm.ngSubmit.emit()" i18n="@@submit_catlogue_details">Submit catlogue details</a>
											</div>
										</div>
									</div>
								</div>

								<div class="tab-pane fade" [class.show]="activeTab == 'product-listing'" [class.active]="activeTab == 'product-listing'" id="product-listing-content" role="tabpanel" aria-labelledby="pills-product-tab">
									<div id="my-store_info" class="without-bg" style="width: 100%">
										<div class="product_listing">
											<!-- <div class="product_listing-main-part" *ngIf="!basicInfo?.marketplace_model?.foodics_is_enable || !basicInfo?.marketplace_model?.foodics_token; else tokenPresent"> -->
											<div class="product_listing-main-part" *ngIf="!productListingType">
												<div class="option-btn-set-up connect_foodics_btn load-content-btn" (click)="generateAuthUrl()" loading="lazy">
													<img src="/images/icons/foodics.png" alt="foodics">
													<span i18n="@@store.connect_to_foodics">Connect to Foodics</span>
												</div>
												<!-- <ng-template #tokenPresent>
													<div class="option-btn-set-up connect_foodics_btn load-content-btn disabled">
														<img src="/images/icons/foodics.png" alt="foodics">
														<span i18n="@@payment_options.connected_with_foodics">Connected with Foodics</span>
													</div>
												</ng-template> -->
												<div class="option-btn-set-up add_manually_bnt" (click)="changeProductListingType('manual')">
													<svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
														<g clip-path="url(#clip0_3921_21350)">
															<path d="M24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7555 10.7452 48.5 24 48.5C37.2555 48.5 48 37.7555 48 24.5C48 11.2452 37.2555 0.5 24 0.5ZM24 45.5472C12.4207 45.5472 3 36.0793 3 24.4999C3 12.9207 12.4207 3.49991 24 3.49991C35.5793 3.49991 45 12.9207 45 24.4999C45 36.0791 35.5793 45.5472 24 45.5472ZM34.5 23H25.5V14C25.5 13.172 24.828 12.5 24 12.5C23.172 12.5 22.5 13.172 22.5 14V23H13.5C12.672 23 12 23.672 12 24.5C12 25.328 12.672 26 13.5 26H22.5V35C22.5 35.828 23.172 36.5 24 36.5C24.828 36.5 25.5 35.828 25.5 35V26H34.5C35.328 26 36 25.328 36 24.5C36 23.672 35.328 23 34.5 23Z" fill="#EB1461"/>
														</g>
														<defs>
															<clipPath id="clip0_3921_21350">
																<rect width="48" height="48" fill="white" transform="translate(0 0.5)"/>
															</clipPath>
														</defs>
													</svg>
													<span i18n="@@store.add_manually">Add manually</span>
												</div>
											</div>
										
											<!-- <ng-template #tokenPresent> -->
												<product *ngIf="activeTab == 'product-listing'"
													(onSelect)="onSelectProducts($event)"
													(onConnectToFoodics)="generateAuthUrl()"
													(onDisconnectFoodics)="onDisconnectFoodics()"
													[foodicsDataFetched]="foodicsDataFetched"
													[productListingType]="productListingType"
													[foodicsConnected]="foodicsAvailble()"
													[isAllowFoodicsSync]="isAllowFoodicsSync"
													(onChangeProductListingType)="onChangeProductListingType($event)"
												></product>												
											<!-- </ng-template> -->

											<div class="connected_foodics-part lazy-content-connected" style="display: none">
											</div>
										</div>
									</div>
								</div>

								<div class="tab-pane fade"  [class.show]="activeTab == 'delivery-options'" [class.active]="activeTab == 'delivery-options'" id="delivery-options-content" role="tabpanel" aria-labelledby="pills-pending-tab">
									<!-- <div id="my-store_info" style="width: 100%">
										<div class="user_info_container">
											<div class="d-flex flex-column mb-2">
												<div class="d-flex align-items-center gap-2 mb-2">
													<div class="custom-checkbox">
														<input type="checkbox" class="select-item orders_inputAll" tm-toggle="allow-delivery-cost" id="include-your-delivery-option" formControlName="same_city" (click)="updateDeliveryOption($event); toggleSildes($event);">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="include-your-delivery-option" i18n="@@allow_delivery_option_within_city">
														Allow delivery option within your city <a href="javascript:void(0)">How does this work?</a>
													</label>
												</div>
												<div class="radio-group d-flex justify-content-start align-items-start flex-column gap-4 pl-4 d-none" id="allow-delivery-cost" [class.d-none]="(f.same_city && f.same_city.value == 0)" >
													<div class="d-flex flex-column gap-3 input_wrapper">
														<div class="d-flex align-items-center gap-3">
															<label i18n="@@define_delivery_cost_within_city">Define delivery cost within your city</label>
														</div>
														<fieldset class="no-label" [ngClass]="{ 'has-error':( isSubmitted || f.delivery_cost_same_city.dirty) && f.delivery_cost_same_city?.errors}">
															<label for="ksa1" class="input-after input-delivery" i18n="@@currency.sar">SAR</label>
															<input type="text" id="ksa1" class="input-delivery" name="delivery-cost-same-city" formControlName="delivery_cost_same_city">
															<span i18n="@@error.required" class="field-error" *ngIf="(isSubmitted || f.delivery_cost_same_city.dirty) && f.delivery_cost_same_city.errors?.required">Required </span>
															<span class="field-error" i18n="@@error.number_only" *ngIf="(isSubmitted || f.delivery_cost_same_city.dirty) && f.delivery_cost_same_city.errors?.pattern">Please enter number only </span>
															<span class="field-error" *ngIf="f.delivery_cost_same_city.errors?.serverError">{{ f.delivery_cost_same_city.errors?.serverError }}</span>
														</fieldset>
													</div>
												</div>
											</div>
											<div class="d-flex flex-column mb-2">
												<div class="d-flex align-items-center gap-2 mb-3">
													<div class="custom-checkbox">
														<input type="checkbox" class="select-item orders_inputAll" tm-toggle="accept-orders-from-outside" id="input-0001" formControlName="outside_city" (click)="outsideCityWithinKsa($event)">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="input-0001" i18n="@@accept_orders_from_outside_city">
														Accept orders from outside your city within KSA
													</label>
												</div>
												<div class="radio-group d-flex justify-content-start align-items-start flex-column gap-4 pl-4 d-none" id="accept-orders-from-outside" [class.d-none]="(f.outside_city && f.outside_city.value == 0)" >
													<div class="d-flex flex-column gap-3 input_wrapper">
														<div class="d-flex align-items-center gap-3">
															<label i18n="@@define_delivery_cost_outside_city">Define delivery cost outside your city within KSA</label>
														</div>
														<fieldset class="no-label"  [ngClass]="{ 'has-error':( isSubmitted || f.delivery_cost_inside_ksa.dirty) && f.delivery_cost_inside_ksa?.errors}">
															<label for="ksa1" class="input-after input-delivery" i18n="@@currency.sar">SAR</label>
															<input type="text" id="ksa1" class="input-delivery" name="delivery-cost-outside-city" formControlName="delivery_cost_inside_ksa" >
															<span i18n="@@error.required" class="field-error" *ngIf="(isSubmitted || f.delivery_cost_inside_ksa.dirty) && f.delivery_cost_inside_ksa.errors?.required">Required </span>
															<span class="field-error" i18n="@@error.number_only" *ngIf="(isSubmitted || f.delivery_cost_inside_ksa.dirty) && f.delivery_cost_inside_ksa.errors?.pattern">Please enter number only </span>
															<span class="field-error" *ngIf="f.delivery_cost_inside_ksa.errors?.serverError">{{ f.delivery_cost_inside_ksa.errors?.serverError }}</span>
														</fieldset>
													</div>
												</div>
											</div>
											<div class="d-flex flex-column">
												<div class="d-flex align-items-center gap-2 mb-3">
													<div class="custom-checkbox">
														<input type="checkbox" class="select-item orders_inputAll" tm-toggle="outside-your-ksa" id="input-0002" formControlName="outside_ksa" (click)="outsideKsa($event)">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<label for="input-0002" i18n="@@allow_orders_outside_ksa">
														Accept orders from outside your KSA
													</label>
												</div>
												<div class="radio-group d-flex justify-content-start align-items-start flex-column gap-4 pl-4" id="outside-your-ksa" [class.d-none]="(f.outside_ksa && f.outside_ksa.value == 0)">
													<div class="d-flex flex-column gap-3 input_wrapper">
														<div class="d-flex align-items-center gap-3">
															<label class="m-0" for="cost1" i18n="@@define_delivery_cost_outside_ksa">Define delivery cost outside your KSA</label>
														</div>
														<fieldset class="no-label"  [ngClass]="{ 'has-error':( isSubmitted || f.delivery_cost_international.dirty) && f.delivery_cost_international?.errors}">
															<label for="ksa1" class="input-after input-delivery" i18n="@@currency.sar">SAR</label>
															<input type="text" id="ksa1" class="input-cost" name="orders-outside-ksa" formControlName="delivery_cost_international" />
															<span i18n="@@error.required" class="field-error" *ngIf="(isSubmitted || f.delivery_cost_international.dirty) && f.delivery_cost_international.errors?.required">Required </span>
															<span class="field-error" i18n="@@error.number_only" *ngIf="(isSubmitted || f.delivery_cost_international.dirty) && f.delivery_cost_international.errors?.pattern">Please enter number only </span>
															<span class="field-error" *ngIf="f.delivery_cost_international.errors?.serverError">{{ f.delivery_cost_international.errors?.serverError }}</span>
														</fieldset>
													</div>
												</div>

											</div>
										</div>
									</div> -->

									
									<div id="my-store_info" style="width: 100%">

										<div class="user_info_container">
											<div class="d-flex align-items-center justify-content-between">
												<div class="d-flex align-items-center gap-2">
													<div class="custom-checkbox">
														<input type="checkbox" class="select-item orders_inputAll" formControlName="allow_instant_delivery" (click)="activateOption($event, 'instant-delivery')">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<div class="d-flex gap-2 align-items-start pointer fs-20 fw-600">
														<ng-container i18n="@@store.activate_instant_delivery">Activate instant delivery option</ng-container>
														<div class="tooltip_wrapper">
															<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
																<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
															<div class="help_tooltip_text">
																<ng-container i18n="@@store.activate_instant_delivery_tooltip">Select which delivery option you would like to enable local delivery (up to 15 km).</ng-container>
																<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																	<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																</svg>
															</div>
														</div>
													</div>
												</div>
									
												<button type="button" routerLink="/wallets" class="secondary_btn small d-none-none gap-2">
													<svg xmlns="http://www.w3.org/2000/svg" width="20" style="margin-right: 10px !important" height="20" viewBox="0 0 20 20" fill="none">
														<path d="M16.25 5.625H3.75C2.71447 5.625 1.875 6.46447 1.875 7.5V15C1.875 16.0355 2.71447 16.875 3.75 16.875H16.25C17.2855 16.875 18.125 16.0355 18.125 15V7.5C18.125 6.46447 17.2855 5.625 16.25 5.625Z" stroke="#EB1461" stroke-width="2" stroke-linejoin="round"/>
														<path d="M16.0687 5.62437V4.4525C16.0687 4.16508 16.0051 3.88122 15.8827 3.62118C15.7603 3.36114 15.582 3.13132 15.3605 2.94813C15.139 2.76494 14.8798 2.63288 14.6015 2.56139C14.3231 2.48989 14.0323 2.48072 13.75 2.53453L3.4625 4.29039C3.01575 4.37552 2.61272 4.61389 2.32291 4.96439C2.0331 5.31488 1.87469 5.75552 1.875 6.21031V8.12437" stroke="#EB1461" stroke-width="2" stroke-linejoin="round"/>
														<path d="M14.375 12.5C14.1278 12.5 13.8861 12.4267 13.6805 12.2893C13.475 12.152 13.3148 11.9568 13.2202 11.7284C13.1255 11.4999 13.1008 11.2486 13.149 11.0061C13.1973 10.7637 13.3163 10.5409 13.4911 10.3661C13.6659 10.1913 13.8887 10.0723 14.1311 10.024C14.3736 9.97579 14.6249 10.0005 14.8534 10.0952C15.0818 10.1898 15.277 10.35 15.4143 10.5555C15.5517 10.7611 15.625 11.0028 15.625 11.25C15.625 11.5815 15.4933 11.8995 15.2589 12.1339C15.0245 12.3683 14.7065 12.5 14.375 12.5Z" fill="#EB1461"/>
													</svg>
													<ng-container i18n="@@store.delivery_wallet">Delivery wallet</ng-container>            
												</button>
												
												<svg class="d-none-block" routerLink="/wallets" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="36" height="36" rx="8" fill="#EB1461" fill-opacity="0.1"/>
													<path d="M25.5 12.75H10.5C9.25736 12.75 8.25 13.7574 8.25 15V24C8.25 25.2426 9.25736 26.25 10.5 26.25H25.5C26.7426 26.25 27.75 25.2426 27.75 24V15C27.75 13.7574 26.7426 12.75 25.5 12.75Z" stroke="#EB1461" stroke-width="2" stroke-linejoin="round"/>
													<path d="M25.2825 12.7492V11.343C25.2824 10.9981 25.2062 10.6575 25.0592 10.3454C24.9123 10.0334 24.6984 9.75759 24.4326 9.53776C24.1668 9.31793 23.8558 9.15946 23.5217 9.07367C23.1877 8.98787 22.8388 8.97687 22.5 9.04143L10.155 11.1485C9.6189 11.2506 9.13526 11.5367 8.78749 11.9573C8.43972 12.3779 8.24963 12.9066 8.25 13.4524V15.7492" stroke="#EB1461" stroke-width="2" stroke-linejoin="round"/>
													<path d="M23.25 21C22.9533 21 22.6633 20.912 22.4166 20.7472C22.17 20.5824 21.9777 20.3481 21.8642 20.074C21.7506 19.7999 21.7209 19.4983 21.7788 19.2074C21.8367 18.9164 21.9796 18.6491 22.1893 18.4393C22.3991 18.2296 22.6664 18.0867 22.9574 18.0288C23.2483 17.9709 23.5499 18.0006 23.824 18.1142C24.0981 18.2277 24.3324 18.42 24.4972 18.6666C24.662 18.9133 24.75 19.2033 24.75 19.5C24.75 19.8978 24.592 20.2794 24.3107 20.5607C24.0294 20.842 23.6478 21 23.25 21Z" fill="#EB1461"/>
												</svg>
											</div>
									
											<div class="checked_expand_block radio-group justify-content-start align-items-start flex-column gap-4 pl-4" [class.d-none]="(f.allow_instant_delivery && ( f.allow_instant_delivery.value == 0 ))">
												<div class="d-flex flex-column gap-3 input_wrapper input_wrapper-checkbox">
													<div class="d-flex align-items-center gap-2 fs-18 fw-600">
														<div class="custom-checkbox">
															<input name='delivery' type="checkbox" class="select-item sub-checkbox" formControlName="allow_local_delivery" (click)="activateOption($event, 'local-delivery')">
															<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
															</svg>
															<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
																<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>
														<ng-container i18n="@@store.local_delivery">Local delivery (less than 15 km)</ng-container>
													</div>
													<div class="input-delivery" [class.d-none]="(f.allow_local_delivery && ( f.allow_local_delivery.value == 0 ))">
														<div class="checked_expand_block">
															<div class="user_info_container">
																<div class="d-flex flex-column gap-2">
																	<ng-container formGroupName="instant_delivery" > 
																		<div class="radio-group d-flex justify-content-start align-items-start flex-column gap-4 pl-4 w-100" id="cost">																			
																			<span class="text-danger">Careem is no longer in operation as of 30 April 2026. Please use Mrsool instead.</span>
																			<ng-container formGroupName="careem" > 																				
																				<div class="d-flex flex-column gap-3 input_wrapper disabled-section">
																					<div class="d-flex align-items-center gap-3 flex-none-column align-items-none-start">
																						<input type="radio" id="cost1" name="local_enabled" class="custom-radio" value="careem" (change)="changeInstantDelivery($event.target.value, 'careem')" [checked]="getInstantDeliveryInfoFormGroup('careem').get('enabled').value">
																						<label class="m-0" for="cost1">
																							<img src="./images/signup/careem.png" alt="" loading="lazy">
																						</label>
																						<span class="date_title">(Jeddah and Riyadh)</span>
																						<div class="addDeliveryDiscount-block" style="display:flex">
																							<button type="button" class="secondary_btn small ml-3 blue_btn addDeliveryDiscount" *ngIf="isAllowDeliveryDiscounts" [class.disabled]="!(getInstantDeliveryInfoFormGroup('careem').get('enabled').value)" (click)="openDeliveryDiscountModel('instant_delivery', 'careem')">
																								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
																									<path d="M10.4375 9.0625V9.5625H10.9375H16.5625C16.6785 9.5625 16.7898 9.60859 16.8719 9.69064C16.9539 9.77269 17 9.88397 17 10C17 10.116 16.9539 10.2273 16.8719 10.3094C16.7898 10.3914 16.6785 10.4375 16.5625 10.4375H10.9375H10.4375V10.9375V16.5625C10.4375 16.6785 10.3914 16.7898 10.3094 16.8719C10.2273 16.9539 10.116 17 10 17C9.88397 17 9.77269 16.9539 9.69064 16.8719C9.60859 16.7898 9.5625 16.6785 9.5625 16.5625V10.9375V10.4375H9.0625H3.4375C3.32147 10.4375 3.21019 10.3914 3.12814 10.3094C3.04609 10.2273 3 10.116 3 10C3 9.88397 3.04609 9.77269 3.12814 9.69064C3.21019 9.60859 3.32147 9.5625 3.4375 9.5625H9.0625H9.5625V9.0625V3.4375C9.5625 3.32147 9.60859 3.21019 9.69064 3.12814C9.77269 3.04609 9.88397 3 10 3C10.116 3 10.2273 3.04609 10.3094 3.12814C10.3914 3.21019 10.4375 3.32147 10.4375 3.4375V9.0625Z" fill="#C7C7C7" stroke="#C7C7C7"/>
																								</svg>
																								<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>												
																							</button>
																							<div class="tooltip_wrapper" [class.d-none]="!(getInstantDeliveryInfoFormGroup('careem').get('enabled').value)">
																								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
																									<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																								</svg>
																								<div class="help_tooltip_text">
																									<ng-container i18n="@@store.delivery_discount_tooltip">Select which delivery option you would like to enable local delivery (up to 15 km).</ng-container>													
																									<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																										<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																									</svg>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="discountList d-flex flex-column gap-3 m-none-0 w-none-100" *ngIf="hasDeliveryDiscount('instant_delivery', 'careem') && getInstantDeliveryInfoFormGroup('careem').get('enabled').value">
																						<div class="addedWorkingHoursBlock flex-column gap-2 ml-3 m-none-0 w-none-100" *ngFor="let discount of getDeliveryDiscounts('instant_delivery', 'careem'); let i = index">
																							<div class="d-flex gap-4 align-items-center w-none-100 justify-none-between">
																								<div class="d-flex gap-2 fs-18 fw-600 color-393939">
																									<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>
																									<span class="color-1C6AB6">{{ discount.delivery_discount }} SAR</span>
																								</div>
																								<div class="d-flex gap-2">
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="editDeliveryDiscount('instant_delivery', 'careem', i)">
																									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
																										<path d="M18 10.0003L14 6.0003M2.5 21.5003L5.88437 21.1243C6.29786 21.0783 6.5046 21.0553 6.69785 20.9928C6.86929 20.9373 7.03245 20.8589 7.18289 20.7597C7.35245 20.6479 7.49955 20.5008 7.79373 20.2066L21 7.0003C22.1046 5.89573 22.1046 4.10487 21 3.0003C19.8955 1.89573 18.1046 1.89573 17 3.0003L3.79373 16.2066C3.49955 16.5008 3.35246 16.6478 3.24064 16.8174C3.14143 16.9679 3.06301 17.131 3.00751 17.3025C2.94496 17.4957 2.92198 17.7024 2.87604 18.1159L2.5 21.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<ng-container i18n="@@button.edit">Edit</ng-container>
																									</button>
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="deleteDeliveryDiscount('instant_delivery', 'careem', i)">
																										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																											<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																										</svg>
																										<ng-container i18n="@@button.delete">Delete</ng-container>
																									</button>
																								</div>
																								<div class="d-flex gap-2 align-items-center">
																									<svg class="d-none-block addDeliveryDiscount" (click)="editDeliveryDiscount('instant_delivery', 'careem', i)" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
																										<rect width="36" height="36" rx="8" fill="#EB1461" fill-opacity="0.1"/>
																										<path d="M24 16.0003L20 12.0003M8.5 27.5003L11.8844 27.1243C12.2979 27.0783 12.5046 27.0553 12.6978 26.9928C12.8693 26.9373 13.0324 26.8589 13.1829 26.7597C13.3525 26.6479 13.4995 26.5008 13.7937 26.2066L27 13.0003C28.1046 11.8957 28.1046 10.1049 27 9.0003C25.8955 7.89573 24.1046 7.89573 23 9.0003L9.79373 22.2066C9.49955 22.5008 9.35246 22.6478 9.24064 22.8174C9.14143 22.9679 9.06301 23.131 9.00751 23.3025C8.94496 23.4957 8.92198 23.7024 8.87604 24.1159L8.5 27.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<svg xmlns="http://www.w3.org/2000/svg" class="d-none-block addDeliveryDiscount" (click)="deleteDeliveryDiscount('instant_delivery', 'careem', i)" width="20" height="20" viewBox="0 0 20 20" fill="none">
																										<path d="M13.3333 4.99935V4.33268C13.3333 3.39926 13.3333 2.93255 13.1517 2.57603C12.9919 2.26243 12.7369 2.00746 12.4233 1.84767C12.0668 1.66602 11.6001 1.66602 10.6667 1.66602H9.33333C8.39991 1.66602 7.9332 1.66602 7.57668 1.84767C7.26308 2.00746 7.00811 2.26243 6.84832 2.57603C6.66667 2.93255 6.66667 3.39926 6.66667 4.33268V4.99935M2.5 4.99935H17.5M15.8333 4.99935V14.3327C15.8333 15.7328 15.8333 16.4329 15.5608 16.9677C15.3212 17.4381 14.9387 17.8205 14.4683 18.0602C13.9335 18.3327 13.2335 18.3327 11.8333 18.3327H8.16667C6.76654 18.3327 6.06647 18.3327 5.53169 18.0602C5.06129 17.8205 4.67883 17.4381 4.43915 16.9677C4.16667 16.4329 4.16667 15.7328 4.16667 14.3327V4.99935" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																								</div>
																							</div>
																							<span class="date_title">{{ formatDiscountDateRange(discount) }}</span>
																							<div class="d-flex align-items-start gap-4">
																								<span class="fs-16 color-393939">{{ formatDiscountDays(discount.days) }}</span>
																								<div class="d-flex flex-column gap-1 fs-16 color-393939">
																									<span *ngFor="let timeRange of formatDiscountTimeRanges(discount.days)">{{ timeRange }}</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</ng-container>

																			<ng-container formGroupName="mrsool" > 
																				<div class="d-flex flex-column gap-3 input_wrapper">
																					<div class="d-flex align-items-center gap-3 flex-none-column align-items-none-start">
																						<input type="radio" id="cost2" name="local_enabled" class="custom-radio" value="mrsool"  (change)="changeInstantDelivery($event.target.value, 'mrsool')" [checked]="getInstantDeliveryInfoFormGroup('mrsool').get('enabled').value">
																						<label class="m-0" for="cost2"><img src="./images/signup/mrsool.png" alt="" loading="lazy"></label>
																						<div class="d-flex align-items-center gap-3">
																							<button type="button" class="secondary_btn small ml-3 blue_btn addDeliveryDiscount" *ngIf="isAllowDeliveryDiscounts" [class.disabled]="!(getInstantDeliveryInfoFormGroup('mrsool').get('enabled').value)" (click)="openDeliveryDiscountModel('instant_delivery', 'mrsool')">
																								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
																									<path d="M10.4375 9.0625V9.5625H10.9375H16.5625C16.6785 9.5625 16.7898 9.60859 16.8719 9.69064C16.9539 9.77269 17 9.88397 17 10C17 10.116 16.9539 10.2273 16.8719 10.3094C16.7898 10.3914 16.6785 10.4375 16.5625 10.4375H10.9375H10.4375V10.9375V16.5625C10.4375 16.6785 10.3914 16.7898 10.3094 16.8719C10.2273 16.9539 10.116 17 10 17C9.88397 17 9.77269 16.9539 9.69064 16.8719C9.60859 16.7898 9.5625 16.6785 9.5625 16.5625V10.9375V10.4375H9.0625H3.4375C3.32147 10.4375 3.21019 10.3914 3.12814 10.3094C3.04609 10.2273 3 10.116 3 10C3 9.88397 3.04609 9.77269 3.12814 9.69064C3.21019 9.60859 3.32147 9.5625 3.4375 9.5625H9.0625H9.5625V9.0625V3.4375C9.5625 3.32147 9.60859 3.21019 9.69064 3.12814C9.77269 3.04609 9.88397 3 10 3C10.116 3 10.2273 3.04609 10.3094 3.12814C10.3914 3.21019 10.4375 3.32147 10.4375 3.4375V9.0625Z" fill="#C7C7C7" stroke="#C7C7C7"/>
																								</svg>
																								<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>
																							</button>
																							<div class="tooltip_wrapper" [class.d-none]="!(getInstantDeliveryInfoFormGroup('mrsool').get('enabled').value)">
																								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
																									<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																								</svg>
																								<div class="help_tooltip_text">
																									<ng-container i18n="@@store.delivery_discount_tooltip">Select which delivery option you would like to enable local delivery (up to 15 km).</ng-container>													
																									<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																										<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																									</svg>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="discountList d-flex flex-column gap-3 m-none-0 w-none-100" *ngIf="hasDeliveryDiscount('instant_delivery', 'mrsool') && getInstantDeliveryInfoFormGroup('mrsool').get('enabled').value">
																						<div class="addedWorkingHoursBlock flex-column gap-2 ml-3 m-none-0 w-none-100" *ngFor="let discount of getDeliveryDiscounts('instant_delivery', 'mrsool'); let i = index">
																							<div class="d-flex gap-4 align-items-center w-none-100 justify-none-between">
																								<div class="d-flex gap-2 fs-18 fw-600 color-393939">
																									<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>
																									<span class="color-1C6AB6">{{ discount.delivery_discount }} SAR</span>
																								</div>
																								<div class="d-flex gap-2">
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="editDeliveryDiscount('instant_delivery', 'mrsool', i)">
																									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
																										<path d="M18 10.0003L14 6.0003M2.5 21.5003L5.88437 21.1243C6.29786 21.0783 6.5046 21.0553 6.69785 20.9928C6.86929 20.9373 7.03245 20.8589 7.18289 20.7597C7.35245 20.6479 7.49955 20.5008 7.79373 20.2066L21 7.0003C22.1046 5.89573 22.1046 4.10487 21 3.0003C19.8955 1.89573 18.1046 1.89573 17 3.0003L3.79373 16.2066C3.49955 16.5008 3.35246 16.6478 3.24064 16.8174C3.14143 16.9679 3.06301 17.131 3.00751 17.3025C2.94496 17.4957 2.92198 17.7024 2.87604 18.1159L2.5 21.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<ng-container i18n="@@button.edit">Edit</ng-container>
																									</button>
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="deleteDeliveryDiscount('instant_delivery', 'mrsool', i)">
																										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																											<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																										</svg>
																										<ng-container i18n="@@button.delete">Delete</ng-container>
																									</button>
																								</div>
																								<div class="d-flex gap-2 align-items-center">
																									<svg class="d-none-block addDeliveryDiscount" (click)="editDeliveryDiscount('instant_delivery', 'mrsool', i)" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
																										<rect width="36" height="36" rx="8" fill="#EB1461" fill-opacity="0.1"/>
																										<path d="M24 16.0003L20 12.0003M8.5 27.5003L11.8844 27.1243C12.2979 27.0783 12.5046 27.0553 12.6978 26.9928C12.8693 26.9373 13.0324 26.8589 13.1829 26.7597C13.3525 26.6479 13.4995 26.5008 13.7937 26.2066L27 13.0003C28.1046 11.8957 28.1046 10.1049 27 9.0003C25.8955 7.89573 24.1046 7.89573 23 9.0003L9.79373 22.2066C9.49955 22.5008 9.35246 22.6478 9.24064 22.8174C9.14143 22.9679 9.06301 23.131 9.00751 23.3025C8.94496 23.4957 8.92198 23.7024 8.87604 24.1159L8.5 27.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<svg xmlns="http://www.w3.org/2000/svg" class="d-none-block addDeliveryDiscount" (click)="deleteDeliveryDiscount('instant_delivery', 'mrsool', i)" width="20" height="20" viewBox="0 0 20 20" fill="none">
																										<path d="M13.3333 4.99935V4.33268C13.3333 3.39926 13.3333 2.93255 13.1517 2.57603C12.9919 2.26243 12.7369 2.00746 12.4233 1.84767C12.0668 1.66602 11.6001 1.66602 10.6667 1.66602H9.33333C8.39991 1.66602 7.9332 1.66602 7.57668 1.84767C7.26308 2.00746 7.00811 2.26243 6.84832 2.57603C6.66667 2.93255 6.66667 3.39926 6.66667 4.33268V4.99935M2.5 4.99935H17.5M15.8333 4.99935V14.3327C15.8333 15.7328 15.8333 16.4329 15.5608 16.9677C15.3212 17.4381 14.9387 17.8205 14.4683 18.0602C13.9335 18.3327 13.2335 18.3327 11.8333 18.3327H8.16667C6.76654 18.3327 6.06647 18.3327 5.53169 18.0602C5.06129 17.8205 4.67883 17.4381 4.43915 16.9677C4.16667 16.4329 4.16667 15.7328 4.16667 14.3327V4.99935" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																								</div>																								
																							</div>
																							<span class="date_title">{{ formatDiscountDateRange(discount) }}</span>
																							<div class="d-flex align-items-start gap-4">
																								<span class="fs-16 color-393939">{{ formatDiscountDays(discount.days) }}</span>
																								<div class="d-flex flex-column gap-1 fs-16 color-393939">
																									<span *ngFor="let timeRange of formatDiscountTimeRanges(discount.days)">{{ timeRange }}</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</ng-container>
																		</div>
																	</ng-container>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="d-flex flex-column gap-3 input_wrapper input_wrapper-checkbox">
													<div class="d-flex align-items-center gap-2 fs-18 fw-600">
														<div class="custom-checkbox">
															<input name='delivery' type="checkbox" class="select-item sub-checkbox" formControlName="allow_same_city_delivery" (click)="activateOption($event, 'within-city-delivery')">
															<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
															</svg>
															<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
																<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>
														<ng-container i18n="@@store.delivery_within_city">Delivery within the same city (~15-25 km)</ng-container>
													</div>
													<div class="input-delivery" [class.d-none]="(f.allow_same_city_delivery && ( f.allow_same_city_delivery.value == 0 ))">
														<div class="checked_expand_block">
															<div class="user_info_container">
																<div class="d-flex flex-column gap-2">
																	<ng-container formGroupName="same_city_delivery" > 
																		<div class="radio-group d-flex justify-content-start align-items-start flex-column gap-4 pl-4 w-100" id="cost">
																			<ng-container formGroupName="mrsool" > 
																				<div class="d-flex flex-column gap-3 input_wrapper">
																					<div class="d-flex align-items-center gap-3 flex-none-column align-items-none-start">
																						<input type="radio" id="cost3" name="same_city_enabled" class="custom-radio" value="mrsool" (change)="changeSameCityDelivery($event.target.value, 'mrsool')" [checked]="getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').value">
																						<label class="m-0" for="cost3"><img src="./images/signup/mrsool.png" alt="" loading="lazy"></label>
																						<div class="d-flex align-items-center gap-3">
																							<button type="button" class="secondary_btn small ml-3 blue_btn addDeliveryDiscount" *ngIf="isAllowDeliveryDiscounts" [class.disabled]="!(getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').value)" (click)="openDeliveryDiscountModel('same_city_delivery', 'mrsool')">
																								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
																									<path d="M10.4375 9.0625V9.5625H10.9375H16.5625C16.6785 9.5625 16.7898 9.60859 16.8719 9.69064C16.9539 9.77269 17 9.88397 17 10C17 10.116 16.9539 10.2273 16.8719 10.3094C16.7898 10.3914 16.6785 10.4375 16.5625 10.4375H10.9375H10.4375V10.9375V16.5625C10.4375 16.6785 10.3914 16.7898 10.3094 16.8719C10.2273 16.9539 10.116 17 10 17C9.88397 17 9.77269 16.9539 9.69064 16.8719C9.60859 16.7898 9.5625 16.6785 9.5625 16.5625V10.9375V10.4375H9.0625H3.4375C3.32147 10.4375 3.21019 10.3914 3.12814 10.3094C3.04609 10.2273 3 10.116 3 10C3 9.88397 3.04609 9.77269 3.12814 9.69064C3.21019 9.60859 3.32147 9.5625 3.4375 9.5625H9.0625H9.5625V9.0625V3.4375C9.5625 3.32147 9.60859 3.21019 9.69064 3.12814C9.77269 3.04609 9.88397 3 10 3C10.116 3 10.2273 3.04609 10.3094 3.12814C10.3914 3.21019 10.4375 3.32147 10.4375 3.4375V9.0625Z" fill="#C7C7C7" stroke="#C7C7C7"/>
																								</svg>
																								<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>
																							</button>
																							<div class="tooltip_wrapper" [class.d-none]="!(getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').value)">
																								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
																									<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																								</svg>
																								<div class="help_tooltip_text">
																									<ng-container i18n="@@store.delivery_discount_tooltip">Select which delivery option you would like to enable local delivery (up to 15 km).</ng-container>													
																									<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																										<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																									</svg>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="discountList d-flex flex-column gap-3 m-none-0 w-none-100" *ngIf="hasDeliveryDiscount('same_city_delivery', 'mrsool') && getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').value">
																						<div class="addedWorkingHoursBlock flex-column gap-2 ml-3 m-none-0 w-none-100" *ngFor="let discount of getDeliveryDiscounts('same_city_delivery', 'mrsool'); let i = index">
																							<div class="d-flex gap-4 align-items-center w-none-100 justify-none-between">
																								<div class="d-flex gap-2 fs-18 fw-600 color-393939">
																									<ng-container i18n="@@store.delivery_discount">Delivery discount</ng-container>
																									<span class="color-1C6AB6">{{ discount.delivery_discount }} SAR</span>
																								</div>
																								<div class="d-flex gap-2">
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="editDeliveryDiscount('same_city_delivery', 'mrsool', i)">
																									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
																										<path d="M18 10.0003L14 6.0003M2.5 21.5003L5.88437 21.1243C6.29786 21.0783 6.5046 21.0553 6.69785 20.9928C6.86929 20.9373 7.03245 20.8589 7.18289 20.7597C7.35245 20.6479 7.49955 20.5008 7.79373 20.2066L21 7.0003C22.1046 5.89573 22.1046 4.10487 21 3.0003C19.8955 1.89573 18.1046 1.89573 17 3.0003L3.79373 16.2066C3.49955 16.5008 3.35246 16.6478 3.24064 16.8174C3.14143 16.9679 3.06301 17.131 3.00751 17.3025C2.94496 17.4957 2.92198 17.7024 2.87604 18.1159L2.5 21.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<ng-container i18n="@@button.edit">Edit</ng-container>
																									</button>
																									<button type="button" class="secondary_btn small addDeliveryDiscount d-none-none" (click)="deleteDeliveryDiscount('same_city_delivery', 'mrsool', i)">
																										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																											<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																										</svg>
																										<ng-container i18n="@@button.delete">Delete</ng-container>
																									</button>
																								</div>
																								<div class="d-flex gap-2 align-items-center">
																									<svg class="d-none-block addDeliveryDiscount" (click)="editDeliveryDiscount('instant_delivery', 'mrsool', i)" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
																										<rect width="36" height="36" rx="8" fill="#EB1461" fill-opacity="0.1"/>
																										<path d="M24 16.0003L20 12.0003M8.5 27.5003L11.8844 27.1243C12.2979 27.0783 12.5046 27.0553 12.6978 26.9928C12.8693 26.9373 13.0324 26.8589 13.1829 26.7597C13.3525 26.6479 13.4995 26.5008 13.7937 26.2066L27 13.0003C28.1046 11.8957 28.1046 10.1049 27 9.0003C25.8955 7.89573 24.1046 7.89573 23 9.0003L9.79373 22.2066C9.49955 22.5008 9.35246 22.6478 9.24064 22.8174C9.14143 22.9679 9.06301 23.131 9.00751 23.3025C8.94496 23.4957 8.92198 23.7024 8.87604 24.1159L8.5 27.5003Z" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																									<svg xmlns="http://www.w3.org/2000/svg" class="d-none-block addDeliveryDiscount" (click)="deleteDeliveryDiscount('instant_delivery', 'mrsool', i)" width="20" height="20" viewBox="0 0 20 20" fill="none">
																										<path d="M13.3333 4.99935V4.33268C13.3333 3.39926 13.3333 2.93255 13.1517 2.57603C12.9919 2.26243 12.7369 2.00746 12.4233 1.84767C12.0668 1.66602 11.6001 1.66602 10.6667 1.66602H9.33333C8.39991 1.66602 7.9332 1.66602 7.57668 1.84767C7.26308 2.00746 7.00811 2.26243 6.84832 2.57603C6.66667 2.93255 6.66667 3.39926 6.66667 4.33268V4.99935M2.5 4.99935H17.5M15.8333 4.99935V14.3327C15.8333 15.7328 15.8333 16.4329 15.5608 16.9677C15.3212 17.4381 14.9387 17.8205 14.4683 18.0602C13.9335 18.3327 13.2335 18.3327 11.8333 18.3327H8.16667C6.76654 18.3327 6.06647 18.3327 5.53169 18.0602C5.06129 17.8205 4.67883 17.4381 4.43915 16.9677C4.16667 16.4329 4.16667 15.7328 4.16667 14.3327V4.99935" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																									</svg>
																								</div>																								
																							</div>
																							<span class="date_title">{{ formatDiscountDateRange(discount) }}</span>
																							<div class="d-flex align-items-start gap-4">
																								<span class="fs-16 color-393939">{{ formatDiscountDays(discount.days) }}</span>
																								<div class="d-flex flex-column gap-1 fs-16 color-393939">
																									<span *ngFor="let timeRange of formatDiscountTimeRanges(discount.days)">{{ timeRange }}</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</ng-container>
																		</div>
																	</ng-container>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="user_info_container">
											<div class="d-flex align-items-center gap-2">
												<div class="custom-checkbox">
													<input type="checkbox" class="select-item orders_inputAll" formControlName="allow_shipping" (click)="activateOption($event, 'shipping-options')">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<div class="d-flex gap-2 align-items-start pointer fs-20 fw-600">
													<ng-container i18n="@@store.activate_shipping_option">Activate shipping option</ng-container>
													<div class="tooltip_wrapper">
														<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
															<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
														<div class="help_tooltip_text">
															<ng-container i18n="@@store.activate_shipping_option_tooltip">Enable this if you want to deliver to customers who are located more than 15 km from you.</ng-container>                    
															<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
															</svg>
														</div>
													</div>
												</div>
											</div>
											<div class="checked_expand_block" [class.d-none]="(f.allow_shipping && ( f.allow_shipping.value == 0 ))">
												<div class="checked_expand_block-row pl-4">
													<div class="input_wrapper w-none-100" style="max-width: 650px;">
														<div class="d-flex align-items-center gap-4 flex-none-column align-items-none-start">
															<img src="./images/signup/oto.png" alt="otoImg" loading="lazy">
															<div class="d-flex align-items-center gap-2 w-100">
																<ng-container *ngIf="basicInfo?.is_oto_info; else otoTemplate">
																	<!-- <button type="button" class="primary_btn w-100" (click)="removeOtoAccount()">Remove</button> -->
																</ng-container>
																<ng-template #otoTemplate>
																	<button type="button" class="secondary_btn w-100" [class.d-none]="showOtoFrom" (click)="openOtoAccount('new_account')">Create OTO account</button>
																	<button type="button" class="primary_btn w-100" [class.d-none]="showOtoFrom" (click)="openOtoAccount('existing_account')">Connect OTO account</button>
																</ng-template>
															</div>
														</div>
													</div>
												</div>
												<div class="checked_expand_block-row pl-4">
													<div class="input_wrapper w-none-100" style="max-width: 650px;" [class.d-none]="!showOtoFrom">
														<oto-tab [userDetails]="basicInfo" [otoAccountType]="otoAccountType"></oto-tab>
													</div>
												</div>
											</div>
										</div>
									
										<div class="user_info_container">
											<div class="d-flex align-items-center gap-2">
												<div class="custom-checkbox">
													<input type="checkbox" class="select-item orders_inputAll" formControlName="allow_self_manage_delivery" (click)="activateOption($event, 'self-managed')">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<div class="d-flex gap-2 align-items-start pointer fs-20 fw-600">
													<ng-container i18n="@@store.activate_self_managed_delivery">Activate self-managed delivery</ng-container>
													<div class="tooltip_wrapper">
														<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
															<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
														<div class="help_tooltip_text">
															<ng-container i18n="@@store.activate_self_managed_delivery_tooltip">Enable this if you want to deliver to customers who are located outside KSA.</ng-container>                    
															<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
															</svg>
														</div>
													</div>
												</div>
											</div>
											<div class="checked_expand_block" [class.d-none]="(f.allow_self_manage_delivery && ( f.allow_self_manage_delivery.value == 0 ))">
												<div class="checked_expand_block-row pl-4 flex-column">
													<ng-container formGroupName="self_manage_delivery" >
														<div class="input_wrapper max-w-500 w-none-100">
															<fieldset class="" [ngClass]="{ 'has-error': isSubmitted && getSelfDeliveryFormGroup('delivery_cost')?.invalid }">
																<label for="internationalksa2">
																	<ng-container i18n="@@store.define_self_managed_delivery_cost">Define self-managed delivery cost</ng-container>
																</label>
																<label for="internationalksa2" class="input-after"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"></label>
																<input type="number" id="internationalksa2" class="input-cost" name="self-managed-delivery" formControlName="delivery_cost" appPreventScroll />
																<span class="field-error" *ngIf="isSubmitted && getSelfDeliveryFormGroup('delivery_cost')?.errors?.required" i18n="@@error.required">Required</span>
															</fieldset>
														</div>
														<div></div>
														<div class="d-flex flex-row gap-4 radius-control flex-none-column align-items-none-start">
															<div class="input_wrapper max-w-500 w-none-100">
																<div class="delivery_radius_container"> 
																	<div class="delivery_radius_wrapper">
																		<div class="delivery_radius_range_wrapper">
																			<input class="p-0 delivery-radius-slider h-4" (change)="deliveryRadius($event.target.value)" formControlName="delivery_radius" type="range" min="1" max="100">
																			<div class="d-flex align-items-center w-100 justify-content-between">
																				<span class="min-value">1 km</span>
																				<span class="max-value">100 km</span>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div class="input_wrapper max-w-150 d-flex align-items-end">
																<fieldset class="" [ngClass]="{ 'has-error': isSubmitted && getSelfDeliveryFormGroup('delivery_radius')?.invalid }">
																	<label for="deliveryRadiusValue" class="input-after unit">km</label>
																	<input type="number" id="deliveryRadiusValue" formControlName="delivery_radius" (change)="deliveryRadius($event.target.value)" min="1" max="100" class="radius-input delivery-radius-value" appPreventScroll>
																	<span class="field-error" *ngIf="isSubmitted && getSelfDeliveryFormGroup('delivery_radius')?.errors?.required" i18n="@@error.required">Required</span>
																</fieldset>
															</div>
														</div>
													</ng-container>
												</div>
											</div>
										</div>
									
										<div class="user_info_container">
											<div class="d-flex align-items-center gap-2">
												<div class="custom-checkbox">													
													<input type="checkbox" class="select-item orders_inputAll" formControlName="allow_pick_up" (click)="activateOption($event, 'pick-up')">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<div class="d-flex gap-2 align-items-start pointer fs-20 fw-600">
													<ng-container i18n="@@store.activate_pick_up_option">Activate pick-up option</ng-container>
													<div class="tooltip_wrapper">
														<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
															<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
														<div class="help_tooltip_text">
															<ng-container i18n="@@store.activate_pick_up_option_tooltip">There is a 2sr charge for every pick up order, kindly input a larger amount if you it to be covered by customers.</ng-container>                    
															<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
															</svg>
														</div>
													</div>
												</div>
											</div>
											<div class="checked_expand_block" [class.d-none]="(f.allow_pick_up && ( f.allow_pick_up.value == 0 || f.allow_pick_up.value == null ))">
												<div class="checked_expand_block-row pl-4">
													<div class="input_wrapper max-w-500 w-none-100">														
														<fieldset class="" [ngClass]="{ 'has-error' : ( isSubmitted || f.pick_up_cost.dirty) && f.pick_up_cost?.errors }">
															<label for="internationalksa1">
																<ng-container i18n="@@store.define_pick_up_cost">Define pick-up cost</ng-container>
															</label>
															<label for="internationalksa1" class="input-after"><img src='/images/icons/sar_symbol_black.svg' loading="lazy"></label>
															<input type="number" id="internationalksa1" class="input-cost" name="orders-outside-ksa" formControlName="pick_up_cost" appPreventScroll />
															<span i18n="@@error.required" class="field-error" *ngIf="(isSubmitted || f.pick_up_cost.dirty) && f.pick_up_cost.errors?.required">Required </span>
															<span class="field-error" i18n="@@error.number_only" *ngIf="(isSubmitted || f.pick_up_cost.dirty) && f.pick_up_cost.errors?.pattern">Please enter number only </span>
															<span class="field-error" *ngIf="f.pick_up_cost.errors?.serverError">{{ f.pick_up_cost.errors?.serverError }}</span>
														</fieldset>
														<!-- <input type="text" id="internationalksa1" class=""> -->
													</div>
													<div></div>
												</div>
											</div>
										</div>

										
										<div class="d-flex w-100 align-items-center justify-content-end mt-4">
											<a href="javascript:void(0)" class="tu-btn blue update" form="ngForm" (click)="informationForm.ngSubmit.emit()" i18n="@@submit_catlogue_details">Submit catlogue details</a>
										</div>
									</div>
								</div>

                                <div class="tab-pane fade" [class.show]="activeTab == 'marketing'" [class.active]="activeTab == 'marketing'" id="marketing-content" role="tabpanel" aria-labelledby="pills-pending-tab">
                                    <div id="promo__code__tab">
                                        <promo-code></promo-code>
                                    </div>
                                </div>


								</form>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</main>
</section>
